function unwrapSchema(schema) {
  let current = schema
  const visited = new Set()

  while (
    current &&
    !current.shape &&
    !current.element &&
    typeof current.unwrap === 'function' &&
    !visited.has(current)
  ) {
    visited.add(current)
    current = current.unwrap()
  }

  return current
}

function getSchemaAtPath(schema, path) {
  if (!schema || !path) return null

  let current = schema

  for (const segment of path.split('.')) {
    current = unwrapSchema(current)

    while (current?.element) {
      current = unwrapSchema(current.element)
    }

    if (!current?.shape?.[segment]) return null
    current = current.shape[segment]
  }

  return unwrapSchema(current)
}

function extractConstraints(schema) {
  if (!schema) return {}

  const min = schema.minLength ?? schema.minValue
  const max = schema.maxLength ?? schema.maxValue
  const constraints = {}

  if (min !== null && min !== undefined) constraints.min = min
  if (max !== null && max !== undefined) constraints.max = max

  return constraints
}

export const getSchemaConstraints = (schema, path) =>
  extractConstraints(getSchemaAtPath(schema, path))

export const getNestedSchemaConstraints = getSchemaConstraints
